import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const ConsoleContainer = styled.div`
  margin: 5px;
`;

export const BoldHover = styled.b`
  cursor: pointer;
`;

export const ConsoleText = styled.p`
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${colors.lightGray};
    `}
`;

export const Table = styled.table`
  margin: 5px;
`;

export const TableHead = styled.thead`
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${colors.fsCyan};
    `}
`;

export const TableBody = styled.tbody`
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${colors.lightGray};
    `}
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 0px;
`;

export const TableData = styled.td`
  text-align: left;
  padding: 0px;
`;
